
import { Brain, Users, Heart, AlertTriangle, Lightbulb } from 'lucide-react';

export const getCategoryIcon = (category: string) => {
  switch (category) {
    case 'overview':
      return Brain;
    case 'traits':
      return Users;
    case 'psychology':
      return Heart;
    case 'clinical':
      return AlertTriangle;
    case 'recommendations':
      return Lightbulb;
    default:
      return Brain;
  }
};

export const getCategoryColor = (category: string) => {
  switch (category) {
    case 'overview':
      return {
        gradient: 'from-purple-500 to-indigo-600',
        bg: 'bg-purple-50',
        border: 'border-purple-200 hover:border-purple-300',
        badge: 'bg-purple-100 text-purple-800 border-purple-200'
      };
    case 'traits':
      return {
        gradient: 'from-blue-500 to-cyan-600',
        bg: 'bg-blue-50',
        border: 'border-blue-200 hover:border-blue-300',
        badge: 'bg-blue-100 text-blue-800 border-blue-200'
      };
    case 'psychology':
      return {
        gradient: 'from-emerald-500 to-teal-600',
        bg: 'bg-emerald-50',
        border: 'border-emerald-200 hover:border-emerald-300',
        badge: 'bg-emerald-100 text-emerald-800 border-emerald-200'
      };
    case 'clinical':
      return {
        gradient: 'from-orange-500 to-red-600',
        bg: 'bg-orange-50',
        border: 'border-orange-200 hover:border-orange-300',
        badge: 'bg-orange-100 text-orange-800 border-orange-200'
      };
    case 'recommendations':
      return {
        gradient: 'from-rose-500 to-pink-600',
        bg: 'bg-rose-50',
        border: 'border-rose-200 hover:border-rose-300',
        badge: 'bg-rose-100 text-rose-800 border-rose-200'
      };
    default:
      return {
        gradient: 'from-gray-500 to-gray-600',
        bg: 'bg-gray-50',
        border: 'border-gray-200 hover:border-gray-300',
        badge: 'bg-gray-100 text-gray-800 border-gray-200'
      };
  }
};

export const getCategoryLabel = (category: string) => {
  switch (category) {
    case 'overview':
      return 'Visão Geral';
    case 'traits':
      return 'Traços';
    case 'psychology':
      return 'Psicologia';
    case 'clinical':
      return 'Clínico';
    case 'recommendations':
      return 'Recomendações';
    default:
      return 'Análise';
  }
};

export const truncateText = (text: string, maxLength: number = 300) => {
  if (!text || typeof text !== 'string') return 'Conteúdo não disponível';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + '...';
};
